import * as React from 'react';

import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';
import { ApplicantEntityIndex } from '@funnels/types';

import { EmailInputField, StringDisplay } from '../../Fields';
import { EditableViewProps, FunnelViewProps, StringReadOnlyViewProps } from '../types';

interface ApplicantEmailEditableViewProps extends EditableViewProps, ApplicantEntityIndex {}

export const ApplicantEmailEditableView = (props: ApplicantEmailEditableViewProps) => {
  const { applicantIndex = 0, ...rest } = props;
  return (
    <EmailInputField
      {...rest}
      name={FIELD_PATHS.APPLICANT_EMAIL(applicantIndex)}
      isFullWidth
      className={PII_FIELD_MASKING_CLASS}
    />
  );
};

interface ApplicantEmailFunnelViewProps extends FunnelViewProps, ApplicantEntityIndex {}

export const ApplicantEmailFunnelView = (props: ApplicantEmailFunnelViewProps) => {
  const { applicantIndex = 0, ...rest } = props;
  return (
    <EmailInputField
      {...rest}
      name={FIELD_PATHS.APPLICANT_EMAIL(applicantIndex)}
      isFullWidth
      className={PII_FIELD_MASKING_CLASS}
    />
  );
};

export const ApplicantEmailReadOnlyView = (props: StringReadOnlyViewProps) => (
  <StringDisplay
    title={'E-mail'}
    value={props.value}
    after={props.after}
    className={PII_FIELD_MASKING_CLASS}
    withEllipsis
  />
);
